module.exports = __webpack_public_path__ + "img/dbamber.b22eb3d1.png";